<template>
  <div>
    <div class="border-bottom  card-no-radius">
      <div class="container">
        <div class="the-header d-flex flex-row align-items-lg-center justify-content-between">
          <!--                      logo-->
          <h3 class="mb-0">
            <router-link to="/">
              <img class="logo-img" src="../../images/header/logo.png">
            </router-link>
          </h3>

          <!-- -->
          <div class="header-right">
            <div v-if="!status_hide_search" class="mb-3 pb-1 d-flex flex-row align-items-center">
              <headerSearch style="height: 40px;width: 420px"/>
              <div class="position-relative">
                <div @click="showAccount(3)" class="header-btn  d-flex flex-row align-items-lg-center justify-content-center">
                  <span>{{ showMainnt }}</span>
<!--                  <span>Testnet</span>-->
                  <img src="../../images/header/arrow-bottom-red.png"/>
                </div>
                <div v-show="showDropMainnet" class="header-drop-box" style="top: 45px;left: 25%">
                  <div @click="goMapScan()" class="header-drop-box-item" @mouseover="showItem=0" @mouseleave="showItem=-1">
                    <div v-show="showItem==0" class="header-btn-line-top"></div>
                    <div class="header-mainnet-round"></div>
                    <span class="header-drop-box-text">MAPO Mainnet</span>
                  </div>
                  <div class="header-drop-line"></div>
                  <div @click="goMapTestnet()" class="header-drop-box-item" @mouseover="showItem=1" @mouseleave="showItem=-1">
                    <div v-show="showItem==1" class="header-btn-line-bottom"></div>
                    <div class="header-mainnet-round"></div>
                    <span class="header-drop-box-text">MAPO Testnet</span>
<!--                    <span class="header-drop-box-text">MAP Testnet</span>-->
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-row align-items-lg-center">

              <div class="header-tab">
                <router-link to="/" @click.native="flushCom"><span>Home</span></router-link>
                <router-link to="/transaction"><span>Transactions</span></router-link>
                <router-link to="/block"><span>Blocks</span></router-link>
                <router-link to="/validators"><span>Validators</span></router-link>
                <div class="header-drop">
                  <div class="header-drop-item" @click="showAccount(1)">
                    <span class="ml-0">Accounts<img class="ml-2" src="../../images/header/arrow-bottom.png"/></span>
                  </div>
                  <div v-show="showDropAccount" class="header-drop-box">
                    <div @click="goAccount()" class="header-drop-box-item" @mouseover="showItem=0" @mouseleave="showItem=1">
                      <div v-show="showItem==0" class="header-btn-line-top"></div>
                      <span class="header-drop-box-text header-drop-box-text-two">All Accounts</span>
                    </div>
                    <div class="header-drop-line"></div>
                    <div @click="goContact()" class="header-drop-box-item" @mouseover="showItem=1" @mouseleave="showItem=1">
                      <div v-show="showItem==1" class="header-btn-line-bottom"></div>
                      <span class="header-drop-box-text header-drop-box-text-two">Verified Contracts</span>
                    </div>
                  </div>
                </div>
                <div class="header-drop">
                  <div class="header-drop-item" @click="showAccount(2)">
                    <span class="ml-0">Tokens<img class="ml-2" src="../../images/header/arrow-bottom.png"/></span>
                  </div>
                  <div v-show="showDropToken" class="header-drop-box" style="left: 0">
                    <div @click="goErcToken()" class="header-drop-box-item" @mouseover="showItem=0" @mouseleave="showItem=1">
                      <div v-show="showItem==0" class="header-btn-line-top"></div>
                      <span  class="header-drop-box-text header-drop-box-text-two">MRC20 Tokens</span>
                    </div>
                    <div class="header-drop-line"></div>
                    <div @click="goErcTransfer()" class="header-drop-box-item" @mouseover="showItem=1" @mouseleave="showItem=1">
                      <div v-show="showItem==1" class="header-btn-line"></div>
                      <span  class="header-drop-box-text header-drop-box-text-two">MRC20 Transfers</span>
                    </div>
                    <div class="header-drop-line"></div>
                    <div @click="goErcSevenToken()" class="header-drop-box-item" @mouseover="showItem=2" @mouseleave="showItem=1">
                      <div v-show="showItem==2" class="header-btn-line"></div>
                      <span  class="header-drop-box-text header-drop-box-text-two">MRC721 Tokens</span>
                    </div>
                    <div class="header-drop-line"></div>
                    <div  @click="goErcSevenTransfer()" class="header-drop-box-item" @mouseover="showItem=3" @mouseleave="showItem=1">
                      <div v-show="showItem==3" class="header-btn-line-bottom"></div>
                      <span class="header-drop-box-text header-drop-box-text-two">MRC721 Transfers</span>
                    </div>
                  </div>
                </div>
              </div>
              <div  v-if="status_hide_search" class="position-relative">
                <div @click="showAccount(3)" class="header-btn  d-flex flex-row align-items-lg-center justify-content-center">
                  <span>{{showMainnt}}</span>
                  <img src="../../images/header/arrow-bottom-red.png"/>
                </div>
                <div v-show="showDropMainnet" class="header-drop-box" style="top: 45px;left: 25%">
                  <div @click="goMapScan()" class="header-drop-box-item" @mouseover="showItem=0" @mouseleave="showItem=-1">
                    <div v-show="showItem==0" class="header-btn-line-top"></div>
                    <div class="header-mainnet-round"></div>
                    <span class="header-drop-box-text">MAPO Mainnet</span>
                  </div>
                  <div class="header-drop-line"></div>
                  <div @click="goMapTestnet()" class="header-drop-box-item" @mouseover="showItem=1" @mouseleave="showItem=-1">
                    <div v-show="showItem==1" class="header-btn-line-bottom"></div>
                    <div class="header-mainnet-round"></div>
<!--                    <span class="header-drop-box-text">MAP Testnet</span>-->
                    <span class="header-drop-box-text">MAPO Testnet</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- search -->
    <div class="container">
      <div class="mt-5 pc-none">
        <headerSearch class="bg-card" style="height: 50px;" />
      </div>
    </div>

  </div>
</template>

<script>
import headerSearch from './header_search.vue'

export default {
  name: 'frameHeader',
  components: {
    headerSearch,
  },
  props: [],
  data() {
    return {
      showMainnt:'Mainnet',//判断测试网名字
      showItem:-1,
      showDropAccount:false, //account下拉框
      showDropToken:false,//token下拉框
      showDropMainnet:false //mainnet下拉框
    }
  },
  computed: {
    status_hide_search(){
      let v = this
      let mark = false
      if(v.$route.path == '/'){
        mark = true
      }
      return mark
    },
  },
  watch: {},
  methods: {
    goMapScan() {
      window.open('https://maposcan.io/','_blank')
    },
    goMapTestnet() {
      window.open('https://testnet.maposcan.io/','_blank')
    },
    flushCom:function(){

      //router是路由实例,例如:var router = new Router({})

      //router.go(n)是路由的一个方法，意思是在history记录中前进或者后退多少步，0就表示还是当前，类似window.history.go(n)


      this.$router.go(0);

    },
    goAccount() {
      this.$router.push('/account')
      this.showDropAccount=false
    },
    goContact() {
      this.$router.push('/verifiedContracts')
      this.showDropAccount=false
    },
    goErcToken() {
      this.$router.push('/mrc20tokens')
      this.showDropToken=false
    },
    goErcTransfer() {
      this.$router.push('/mrc20transfers')
      this.showDropToken=false
    },
    goErcSevenToken() {
      this.$router.push('/mrc721tokens')
      this.showDropToken=false
    },
    goErcSevenTransfer() {
      this.$router.push('/mrc721transfers')
      this.showDropToken=false
    },
    //展示数据
    showAccount(num) {
      let v = this
      if (num==1) {
        v.showDropAccount=!v.showDropAccount
        v.showDropToken=false
        v.showDropMainnet=false
      }
      else if (num==2) {
        v.showDropToken=!v.showDropToken
        v.showDropAccount=false
        v.showDropMainnet=false
      }
      else if (num==3) {
        v.showDropMainnet=!v.showDropMainnet
        v.showDropAccount=false
        v.showDropToken=false
      }
    }
  },
  created() {

  },
  mounted() {
    if (document.location.href=='https://maposcan.io/'){
      this.showMainnt = 'Mainnet'
    }
    else if(document.location.href=='https://testnet.maposcan.io/') {
      this.showMainnt = 'Testnet'
    }

  },
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
.the-header{
  padding: 20px 0;
  a{
    text-decoration: none !important;
    color: #333 !important;
  }
  .logo-img{
    width: 179px;
    vertical-align: middle;
    margin-top: -5px;
  }
  .logo-text{
    width: 110px;
    margin-left: 5px;
  }
  .search-box{
    margin-left: auto;
  }
}

.header-tab {
  font-family: 'poppinsMeduim';
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  display: flex;
  flex-direction: row;
  align-items: center;
  span {
    margin-left: 58px;
    cursor: pointer;
    img {
      width: 12px;
    }
  }
  span:hover {
    color: #3772ff;
  }
}

.header-btn {
  font-family: 'poppinsMeduim';
  margin-left: 63px;
  box-sizing: border-box;
  width: 184px;
  height: 40px;
  border-radius: 10px;
  background-color: white;
  cursor: pointer;
  font-weight: 500;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  img {
    margin-left: 11px;
    width: 11px;
    height: 8px;
  }
}

.header-btns {
  margin-left: 10px;
  border: 1px solid #E44E3A;
}

.header-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.header-drop {
  position: relative;
}

.header-drop-item {
  margin-left: 58px;
  span {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
}

.header-drop-box {
  width: 184px;
  position: absolute;
  z-index: 9;
  top: 25px;
  left: 50px;
  background: #FFFFFF;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
  border-radius: 3px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: default;
}

.header-drop-box-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  height: 41px;
  width: 100%;
  cursor: pointer;
}

.header-drop-box-item:hover {
  .header-drop-box-text {
    color:#3772ff ;
  }
  .header-mainnet-round {
    margin-left: 18px !important;
  }
  .header-drop-box-text-two {
    margin-left: 31px !important;
  }
}

.header-btn-line-top {
  height: 42px !important;
  width: 2px !important;
  background-color: #3772ff;
  border-radius: 3px 0 0 0 ;
  margin-left: 0 !important;
}

.header-drop-box-text {
  font-size: 12px;
}

.header-drop-box-text-two {
  margin-left: 33px !important;
}



.header-btn-line {
  height: 42px !important;
  width: 2px !important;
  background-color: #3772ff;
}

.header-btn-line-bottom {
  height: 42px !important;
  width: 2px !important;
  background-color: #3772ff;
  border-radius: 0 0 0 3px ;
}


.header-mainnet-round {
  width: 4px !important;
  height: 4px !important;
  border-radius: 50%;
  background: #3772ff;
  padding: 0 !important;
  margin-right: 9px;
  margin-left: 20px;
}

.header-drop-line {
  width: 100%;
  height: 1px;
  background: rgba(55, 114, 255, 0.1)
}

@media(max-width: 788px){
  .the-header{
    .search-box{
      width: 100%;
      flex: 1;
      margin-top: 12px;
    }
  }
}

@media (max-width: 1200px) {
  .header-tab  {
    span {
      margin-left: 30px;
    }
  }
  .header-drop-item {
    margin-left: 30px;
  }
  .header-btn {
    margin-left: 30px;
  }
}
</style>
